// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rd7s","input":"styles_input__64NhM"};